import FormBuilderDataTable from "containers/admin/clients/client/components/form-builder/form-builder-data-table";
import { renderSectionHeading } from "containers/admin/clients/client/components/form-builder/form-builder-section-heading";
import { buildFlatDynamicSectionTableData } from "containers/admin/clients/client/components/form-builder/form-builder-viewer-utils";
import type {
  JsonFormObjectSchema,
  JsonFormSchema,
  JsonFormSectionHeadingLevel,
} from "containers/admin/clients/client/components/form-builder/form-schema";

type DynamicSectionRow = Record<string, unknown>;

type FormBuilderViewerFlatDynamicSectionProps = {
  title: string;
  headingLevel?: JsonFormSectionHeadingLevel;
  itemSchema: JsonFormObjectSchema;
  rows: DynamicSectionRow[];
};

const FormBuilderViewerFlatDynamicSection = ({
  title,
  headingLevel = "subsection",
  itemSchema,
  rows,
}: FormBuilderViewerFlatDynamicSectionProps) => {
  const { columns, rows: tableRows } = buildFlatDynamicSectionTableData(itemSchema, rows);

  if (tableRows.length === 0) {
    return null;
  }

  return (
    <div className="flex w-full flex-col gap-3">
      {title.trim() && renderSectionHeading(title, headingLevel)}
      <FormBuilderDataTable columns={columns} rows={tableRows} />
    </div>
  );
};

export default FormBuilderViewerFlatDynamicSection;
